import { type FC, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import {
  DirectContactFormTextField,
  type ResolvedContactFormSubject,
} from '../../../direct-contact'

import { type DirectContactFormValues } from './DirectContactFormModel'
import { DirectContactFormOrderProductsSelection } from './DirectContactFormOrderProductsSelection/DirectContactFormOrderProductsSelection'

export const DirectContactFormOrderNumberField: FC<{
  isLoggedIn: boolean
  resolvedSubject: ResolvedContactFormSubject
}> = ({ isLoggedIn, resolvedSubject }) => {
  const intl = useIntl()
  const { clearErrors } = useFormContext<DirectContactFormValues>()
  const shouldShowOptionalOrderNumber =
    resolvedSubject.policy.orderNumberRequirement === 'optional'
  const shouldShowOrderNumber =
    resolvedSubject.policy.orderNumberRequirement === 'required'
  const shouldRenderOptionalOrderNumber =
    !isLoggedIn && shouldShowOptionalOrderNumber
  const requiredMessage = intl.formatMessage({
    id: 'form.error.input.missing',
  })

  useEffect(() => {
    if (isLoggedIn) {
      clearErrors(['orderId', 'productCode'])
    }
  }, [clearErrors, isLoggedIn])

  useEffect(() => {
    if (shouldRenderOptionalOrderNumber) {
      clearErrors('orderId')
    }
  }, [clearErrors, shouldRenderOptionalOrderNumber])

  if (shouldShowOrderNumber) {
    if (isLoggedIn) {
      return (
        <DirectContactFormOrderProductsSelection
          isProductType={resolvedSubject.policy.isProductRelated}
        />
      )
    }

    return (
      <DirectContactFormTextField
        clearErrorOnClick
        data-qa-id="contact-form-orderId"
        label={intl.formatMessage({ id: 'general.label.ordernumber' })}
        name="orderId"
        required
        rules={{ required: requiredMessage }}
      />
    )
  }

  if (shouldRenderOptionalOrderNumber) {
    return (
      <DirectContactFormTextField
        clearErrorOnClick
        data-qa-id="contact-form-orderId"
        label={intl.formatMessage({ id: 'general.label.ordernumber' })}
        name="orderId"
        rules={{ required: false }}
      />
    )
  }

  return null
}
